interface DxfVisualPreviewProps {
  geometry: Record<string, unknown>;
}

type Point = [number, number];

export function DxfVisualPreview({ geometry }: DxfVisualPreviewProps) {
  const plot = pointArray(geometry.plot_polygon);
  const footprint = pointArray(geometry.building_footprint);
  const regulationLine = pointArray(geometry.regulation_line);
  const bounds = boundsArray(geometry.bounds);
  if (!bounds || (!plot.length && !footprint.length && !regulationLine.length)) return null;

  const [minX, minY, maxX, maxY] = bounds;
  const width = Math.max(maxX - minX, 1);
  const height = Math.max(maxY - minY, 1);
  const size = 260;
  const pad = 12;
  const scale = Math.min((size - pad * 2) / width, (size - pad * 2) / height);
  const points = (poly: Point[]) =>
    poly
      .map(([x, y]) => `${pad + (x - minX) * scale},${size - pad - (y - minY) * scale}`)
      .join(" ");

  return (
    <div className="mt-4 rounded-lg border border-stone-200 bg-white p-3 text-left">
      <div className="mb-2 text-xs font-bold uppercase tracking-wide text-stone-500">
        QA pregled geometrije
      </div>
      <svg viewBox={`0 0 ${size} ${size}`} className="h-56 w-full rounded bg-stone-50">
        {plot.length > 0 && (
          <polygon points={points(plot)} fill="none" stroke="#b000b8" strokeWidth="2" />
        )}
        {footprint.length > 0 && (
          <polygon
            points={points(footprint)}
            fill="rgba(220,38,38,0.16)"
            stroke="#dc2626"
            strokeWidth="2"
          />
        )}
        {regulationLine.length > 0 && (
          <polyline
            points={points(regulationLine)}
            fill="none"
            stroke="#2563eb"
            strokeDasharray="6 4"
            strokeWidth="2"
          />
        )}
      </svg>
      <div className="mt-2 flex flex-wrap gap-3 text-[0.72rem] text-stone-600">
        <span>Parcel: ljubičasto</span>
        <span>KIG: crveno</span>
        <span>Regulacijski pravac: plavo</span>
      </div>
    </div>
  );
}

function pointArray(value: unknown): Point[] {
  if (!Array.isArray(value)) return [];
  return value.flatMap((item) => {
    if (!Array.isArray(item) || item.length < 2) return [];
    const x = Number(item[0]);
    const y = Number(item[1]);
    return Number.isFinite(x) && Number.isFinite(y) ? [[x, y] as Point] : [];
  });
}

function boundsArray(value: unknown): [number, number, number, number] | null {
  if (!Array.isArray(value) || value.length !== 4) return null;
  const parsed = value.map(Number);
  return parsed.every(Number.isFinite) ? (parsed as [number, number, number, number]) : null;
}
